import {
  containerVariants,
  imageContainerVariants,
  contentContainerVariants,
} from '@/components/skeletons/ArticleCardSkeleton.styles';

import type { VariantProps } from 'class-variance-authority';

interface ArticleCardSkeletonProps extends VariantProps<typeof containerVariants> {
  className?: string;
  summaryLineCount?: number;
  background?: 'grey' | 'white';
}

function ArticleCardSkeleton({
  layout,
  imagePosition,
  className,
  background = 'grey',
  summaryLineCount = 2,
}: ArticleCardSkeletonProps) {
  return (
    <article
      className={`${containerVariants({ layout, imagePosition })} ${className ?? ''} ${background === 'grey' ? '!bg-[#fafafa]' : '!bg-white'}`}
    >
      <div className={imageContainerVariants({ layout, imagePosition })} />
      <div className={contentContainerVariants({ layout })}>
        <div className='h-4 md:h-5 mt-1 md:mt-3 -mb-1.5 bg-gray-200 animate-pulse rounded-full w-full' />
        <div className='h-4 md:h-5 bg-gray-200 animate-pulse rounded-full w-2/5 mt-3' />

        <div className='hidden md:block space-y-2 mt-3'>
          {Array.from({ length: summaryLineCount }).map((_, index) => (
            <div
              key={index}
              className={`h-4 bg-gray-200 -mb-1 animate-pulse rounded-full ${index === 0 ? 'w-full' : 'w-3/5'}`}
            />
          ))}
        </div>

        <div className='flex gap-2 mt-auto pt-4'>
          <div className='h-[17px] bg-gray-200 animate-pulse rounded-full w-20' />
          <div className='h-[17px] bg-gray-200 animate-pulse rounded-full w-20' />
        </div>

        <div className='flex items-center gap-2 mt-3'>
          <div className='h-6 w-6 bg-gray-200 animate-pulse rounded-full' />
          <div className='flex flex-col gap-1'>
            <div className='h-3 bg-gray-200 animate-pulse rounded w-28' />
            <div className='h-3 bg-gray-200 animate-pulse rounded w-20' />
          </div>
        </div>
      </div>
    </article>
  );
}

export default ArticleCardSkeleton;
